import React from "react";
import "./TabBar.css";
import {Nav, NavItem, NavLink} from "reactstrap";
import TextLabel from "../Controls/TextLabel.mjs";
import ElapsedTimer from "../Controls/ElapsedTimer.mjs";
import RemoteAccessIndicator from "../Controls/RemoteAccessIndicator.mjs";

const G = window.glob;

const calcUnread = () => {
	return (G.getStatus('UnreadMailCount')||0)+(G.getStatus('UnreadImCount')||0);
}

const TabBar = class extends React.Component {
	constructor(props) {
		super(props);
		const mo = G.getStatus('mainOperation');
		this.state={
			copione: G.getStatus('Copione'),
			player: G.getStatus('Player'),
			hidden: (mo?.name !== 'Game'),
			tab: (mo?.params?.tab ?? 'Game'),
			hasgame: !! G.getStatus('GameChosen')?.id,
			unreadCount: calcUnread()
		};
		this.chooseTab = this.chooseTab.bind(this);
		this.uid = G.generateUid('TabBar');
	}
	componentDidMount() {
		G.register('Player', (p)=>{
			this.setState({ player: p });
		}, this.uid);
		G.register('Copione', (c)=>{
			this.setState({ copione: c });
		}, this.uid);
		G.register('mainOperation', (m)=>{
			this.setState({ hidden: (m.name !== 'Game') });
			this.setState({ tab: m?.params?.tab ?? 'Dashboard' });
		}, this.uid);
		G.register('GameChosen', (gc)=>{
			this.setState({ hasgame: !! gc?.id });
		}, this.uid);
		G.register('UnreadMailCount', ()=>{
			this.setState({ unreadCount: calcUnread() });
		}, this.uid);
		G.register('UnreadImCount', ()=>{
			this.setState({ unreadCount: calcUnread() });
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	chooseTab(v) {
		G.setCurrentPageParam('tab',v);
		if ( v === 'Dashboard' && this.state.NotifyDashboard ) G.setStatus('NotifyDashboard', false);
		this.setState({ menuActive: false });
	}
	render() {
		if ( this.state.hidden ) return '';
		if ( ! this.state.player ) return '';
		if ( ! this.state.copione ) return '';
		const tabs = [];
		// if ( this.state.player ) tabs.push(
		// 	<NavItem key={"Game"}>
		// 		<NavLink
		// 			className={ this.state.tab === 'Game' ? "active" : "inactive"}
		// 			onClick={ ()=>{  this.chooseTab('Game')} }
		// 		>
		// 			<TextLabel value={"Game"} />
		// 		</NavLink>
		// 	</NavItem>
		// );
		if ( this.state.player ) tabs.push(
			<NavItem key={"Dashboard"}>
				<NavLink
					className={
						(this.state.tab === 'Dashboard' ? "active" : "inactive")+
						( this.state.unreadCount ? ' showNotificationBullet' : '')
					}
					onClick={ ()=>{  this.chooseTab('Dashboard')} }
				>
					<TextLabel value={"Dashboard"} />
				</NavLink>
			</NavItem>
		);
		if ( this.state.hasgame && this.state.player?.admin?.seeLog ){
			tabs.push(
				<NavItem key={"Log"}>
					<NavLink
						className={ this.state.tab === 'Backstage' ? "active" : "inactive"}
						onClick={ ()=>{  this.chooseTab('Backstage')} }
					>
						<TextLabel value={"Backstage"} />
					</NavLink>
				</NavItem>
			);
			tabs.push(
				<NavItem key={"UserList"}>
					<NavLink
						className={ this.state.tab === 'UserList' ? "active" : "inactive"}
						onClick={ ()=>{  this.chooseTab('UserList')} }
					>
						<TextLabel value={"UserList"} />
					</NavLink>
				</NavItem>
			);
		}
		if ( this.state.copione && this.state.player?.admin ) tabs.push(
			<NavItem key={"ScriptBook"} className={"desktoponly"}>
				<NavLink
					className={ this.state.tab === 'ScriptBook' ? "active" : "inactive"}
					onClick={ ()=>{  this.chooseTab('ScriptBook')} }
				>
					<TextLabel value={"ScriptBook"} />
				</NavLink>
			</NavItem>
		);
		return(
			<div id={this.uid} className={'TabBar'}>
				<RemoteAccessIndicator />
				<ElapsedTimer />
				<div
					className={"MenuTrigger mobileonly"}
					onClick={ (e)=>{ e.preventDefault(); e.stopPropagation(); this.setState({menuActive: ! this.state.menuActive }) } }
					onDoubleClick={ (e)=>{ e.preventDefault(); e.stopPropagation(); } }
				>
					<span/>
				</div>
				<Nav
					tabs={true}
					className={ this.state.menuActive ? 'active' : 'inactive' }
				>
					{ tabs }
					<NavItem key={"UserInfo"}>
						<NavLink
							className={ this.state.tab === 'UserInfo' ? "active" : "inactive"}
							onClick={ ()=>{  this.chooseTab('UserInfo')} }
						>
							<TextLabel value={"UserInfo"} />
						</NavLink>
					</NavItem>
				</Nav>
			</div>
		)
	}
}

export default TabBar;